export const BASE_URL = process.env.NODE_ENV === 'development' ? process.env.VITE_DEV_MODE : process.env.VITE_PRO_MODE;

export const IMPERSONATE_LINK =
    process.env.NODE_ENV === 'development' ? process.env.VITE_IV_DEV_MODE : process.env.VITE_IV_PRO_MODE;

// Dashboard
export const DASHBOARD_URL = BASE_URL + 'admin/dashboard';

// Authentication
export const LOGIN_URL = BASE_URL + 'auth/login';
export const VERIFY_URL = BASE_URL + 'auth/2fa/verify';
export const RESET_CODE_URL = BASE_URL + 'auth/2fa/resend/code';

// Admin
export const LIST_USERS_URL = BASE_URL + 'admin/users';

// Supervisor
export const SUPERVISOR_URL = BASE_URL + 'admin/supervisor';

//Access Rights
export const ACCESS_RIGHT_URL = BASE_URL + 'admin/access-rights';

export const BRAND_ACCESS_RIGHT_URL = BASE_URL + 'admin/brand-acl';

// Enums
export const ENUMS_URL = BASE_URL + 'enums';

// Agency
export const LIST_AGENCY_URL = BASE_URL + 'admin/agencies';

// Campaign
export const LIST_CAMPAIGN_URL = BASE_URL + 'admin/campaigns';

export const CAMPAIGN_REVIEW_URL = BASE_URL + 'admin/campaigns/review';

export const CAMPAIGN_BUDGET_URL = BASE_URL + 'admin/campaigns/budget';

export const CAMPAIGN_BUDGET_DOWNLOAD_URL = BASE_URL + 'admin/campaigns/budget/download';

export const LIST_CAMPAIGN_EMAILING_URL = BASE_URL + 'admin/campaigns/emailing';

export const CAMPAIGN_GOALS_URL = BASE_URL + 'admin/campaigns/goal';

export const CAMPAIGN_GOAL_TOGGLE_URL = BASE_URL + 'admin/campaigns/goal/toggle';

export const CAMPAIGN_TYPES_URL = BASE_URL + 'admin/campaigns/creator-type';

export const CAMPAIGN_TYPE_TOGGLE_URL = BASE_URL + 'admin/campaigns/creator-type/toggle';

export const CAMPAIGN_BUDGET_RANGE_URL = BASE_URL + 'admin/campaigns/budget-range';

export const CAMPAIGN_IS_PICKED_URL = BASE_URL + 'admin/campaigns/toggle/picked';

export const CAMPAIGN_COMPLETE_OFFERS = BASE_URL + 'admin/campaigns/complete/offers';

export const INFLUENCERS_DOWNLOAD_URL = BASE_URL + 'admin/users/influencers/download';

export const CAMPAIGN_LIST_DOWNLOAD_URL = BASE_URL + 'admin/campaigns/download/export/campaigns';

export const COMPANY_LIST_DOWNLOAD_URL = BASE_URL + 'admin/company/download/export';

export const INVOICE_LIST_DOWNLOAD_URL = BASE_URL + 'admin/invoicing/v2/download/export';

export const REPORTING_LIST_DOWNLOAD_URL = BASE_URL + 'admin/report/download/export';

// Offer
export const LIST_OFFER_URL = BASE_URL + 'admin/offers';
export const OFFER_LIST_DOWNLOAD_URL = BASE_URL + 'admin/offers/download/export';

// Offer PDF
export const LIST_OFFER_PDF_URL = BASE_URL + 'admin/offer-pdfs';
export const OFFER_PDF_OFFERS_AUTOCOMPLETE_URL = BASE_URL + 'admin/offer-pdfs/offers';
export const OFFER_PDF_CAMPAIGNS_AUTOCOMPLETE_URL = BASE_URL + 'admin/offer-pdfs/campaigns';
export const OFFER_PDF_INFLUENCERS_AUTOCOMPLETE_URL = BASE_URL + 'admin/offer-pdfs/influencers';
export const OFFER_PDF_SENT_BY_AUTOCOMPLETE_URL = BASE_URL + 'admin/offer-pdfs/sent-by';
export const LIST_CONTRACT_PDF_URL = BASE_URL + 'admin/contract-pdfs';
export const CONTRACT_PDF_CONTRACTS_AUTOCOMPLETE_URL = BASE_URL + 'admin/contract-pdfs/contracts';
export const CONTRACT_PDF_CAMPAIGNS_AUTOCOMPLETE_URL = BASE_URL + 'admin/contract-pdfs/campaigns';
export const CONTRACT_PDF_INFLUENCERS_AUTOCOMPLETE_URL = BASE_URL + 'admin/contract-pdfs/influencers';
export const CONTRACT_PDF_SENT_BY_AUTOCOMPLETE_URL = BASE_URL + 'admin/contract-pdfs/sent-by';

// Contract
export const CONTRACT_LIST_DOWNLOAD_URL = BASE_URL + 'admin/contracts/download/export';
export const LIST_CONTRACT_URL = BASE_URL + 'admin/contracts';

// Invoicing
export const INVOICING_URL = BASE_URL + 'admin/invoicing';

// Onboarding
export const ONBOARDING_URL = BASE_URL + 'admin/users/onboarding';

// Packages
export const PACKAGES_URL = BASE_URL + 'admin/packages';

// Override
export const OVERRIDE_URL = BASE_URL + 'admin/override';

// Export
export const EXPORT_URL = BASE_URL + 'admin/offers';

// Reporting
export const REPORTING_URL = BASE_URL + 'admin/report';

// Statistics
export const STATISTICS_URL = BASE_URL + 'admin/statistics';

// Partner
export const PARTNER_URL = BASE_URL + 'admin/partners';
export const PARTNER_CAMPAIGN_URL = BASE_URL + 'admin/partner-campaigns';

// Company
export const COMPANY_URL = BASE_URL + 'admin/company';

// Platform
export const PLATFORM_URL = BASE_URL + 'admin/platform';
export const PLATFORM_ITEM_URL = BASE_URL + 'admin/platform/item';

export const SOCIAL_COMMAND_URL = BASE_URL + 'social/command';

export const AUTH_ME = BASE_URL + 'auth/me';

// Discovery
export const LIST_DISCOVERY_SEARCH = BASE_URL + 'admin/discovery/search';
export const LIST_DISCOVERY_PROFILE = BASE_URL + 'admin/discovery/profile';
export const LIST_DISCOVERY_OVERVIEW = BASE_URL + 'admin/discovery/overview';
export const LIST_DISCOVERY_PRESETS = BASE_URL + 'admin/discovery/filter/presets';
export const COMPANY_EDIT_TOKENS = BASE_URL + 'admin/discovery/company';

// Controlling
export const CONTROLLING_URL = BASE_URL + 'admin/controlling';
export const CONTROLLING_INCOMING_DEFERRAL_URL = BASE_URL + 'admin/controlling/incoming-deferral';
export const CONTROLLING_INCOMING_INVOICES_URL = BASE_URL + 'admin/controlling/incoming-invoices';
export const CONTROLLING_OUTGOING_INVOICES_URL = BASE_URL + 'admin/controlling/outgoing/invoices';
export const CONTROLLING_LONG_TERM_INCOMING_INVOICES_URL = BASE_URL + 'admin/controlling/long/incoming/invoices';
export const CONTROLLING_KPI_URL = BASE_URL + 'admin/controlling/kpi';
export const CONTROLLING_AGENCY_REVENUE_CAMPAIGNS_URL = BASE_URL + 'admin/controlling/agency/revenue/campaigns';
export const CONTROLLING_AGENCY_REVENUE_COMPANIES_URL = BASE_URL + 'admin/controlling/agency/revenue/companies';
// Modash
export const MODASH_HEALTH_URL = BASE_URL + 'modash/service/health/all';

export const DOWNLOAD_INVOICE = BASE_URL + 'admin/invoicing/download';

export const OFFER_EVENT_TRANSFER_URL = BASE_URL + 'admin/offer-event-transfer';
export const OFFER_EVENT_TRANSFER_PREVIEW_URL = BASE_URL + 'admin/offer-event-transfer/preview';
export const OFFER_EVENT_TRANSFER_OFFERS_URL = BASE_URL + 'admin/offer-event-transfer/offers';
